import { render, staticRenderFns } from "./LiquidacionDetalleModal.vue?vue&type=template&id=231702b2"
import script from "./LiquidacionDetalleModal.vue?vue&type=script&lang=js"
export * from "./LiquidacionDetalleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports